import { IMenu } from '@dfl/mui-react-common';
import { PRODUCT_PERMISSIONS } from 'modules/inventory/product/constants';
import { WAREHOUSE_PERMISSIONS } from 'modules/inventory/warehouse/constants';
import { SupplierIcon } from 'modules/inventory/common/components/Icons/SupplierIcon';
import { LogisticIcon } from 'modules/inventory/common/components/Icons/LogisticIcon';
import DriveEtaOutlinedIcon from '@mui/icons-material/DriveEtaOutlined';
/* import { ManufactureIcon } from 'modules/inventory/common/components/Icons/ManufactureIcon';
import { MANUFACTURE_PERMISSIONS } from 'modules/inventory/provider/manufacture/constants'; */
import { LOGISTICS_PERMISSIONS } from 'modules/inventory/provider/logistics/constants';
import { SUPPLIER_PERMISSIONS } from 'modules/inventory/provider/supplier/constants';
import { CATEGORY_PERMISSIONS } from 'modules/inventory/settings/category/constants';
import { CategoryIcon } from 'modules/inventory/common/components/Icons/CategoryIcon';
import { WAREHOUSE_AREA_PERMISSIONS } from 'modules/inventory/settings/warehouse-area/constants';
import { TAGS_PERMISSIONS } from 'modules/inventory/settings/tags/constants';
import { STOCK_REDUCTION_CAUSE_PERMISSIONS } from 'modules/inventory/settings/stock-reduction-cause/constants';
import { WarehouseIcon } from 'modules/inventory/common/components/Icons/WarehouseIcon';
import { DistributionCenterIcon } from 'modules/inventory/common/components/Icons/DistributionCenterIcon';
import { WarehouseAreaIcon } from 'modules/inventory/common/components/Icons/WarehouseAreaIcon';
import { ReductionCauseIcon } from 'modules/inventory/common/components/Icons/ReductionCauseIcon';
import { TagsIcon } from 'modules/inventory/common/components/Icons/TagsIcon';
import ProductIcon from 'modules/inventory/common/components/Icons/ProductIcon';
import { DISTRIBUTION_CENTER_PERMISSIONS } from 'modules/inventory/distribution-centers/constants';
import { ProductFeatureIcon } from 'modules/inventory/common/components/Icons/ProductFeatureIcon';
import { ProviderIcon } from 'modules/inventory/common/components/Icons/ProviderIcon';
import { AssessmentOutlined } from '@mui/icons-material';
import { CARRIER_PERMISSIONS } from 'modules/inventory/provider/carriers/constants';
import { disabledTags, disabledProductVariant, disableWarehouseAreas, disabledStockReductionCause } from 'utils/flags-utils';
import { LABELS_PERMISSIONS } from 'modules/inventory/settings/labels/constants';
import { PROVIDER_FIELD_PERMISSIONS } from 'modules/inventory/settings/provider-field/constants';
import { PRODUCT_TEMPLATE_PERMISSIONS } from 'modules/inventory/settings/product-templates/constants';
import DynamicFormOutlinedIcon from '@mui/icons-material/DynamicFormOutlined';

export const INVENTORY_MENU: IMenu[] = [
  {
    title: 'main_menu.admin.section.inventory.title',
    prefix: '/inventory',
    atLessOne: true,
    items: [
      {
        title: 'main_menu.admin.section.inventory.products',
        path: '/inventory/products',
        partialMatch: true,
        icon: <ProductIcon fontSize='small' />,
        permissions: [PRODUCT_PERMISSIONS.PRODUCT_VIEW],
      },
      {
        title: 'main_menu.admin.section.inventory.warehouses',
        path: '/inventory/warehouses',
        partialMatch: true,
        icon: <WarehouseIcon fontSize='small' />,
        permissions: [WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW],
      },
      {
        title: 'main_menu.admin.section.inventory.distribution-centers',
        path: '/inventory/distribution-centers',
        partialMatch: true,
        icon: <DistributionCenterIcon fontSize='small' />,
        permissions: [DISTRIBUTION_CENTER_PERMISSIONS.DISTRIBUTION_CENTER_VIEW],
      },
    ],
  },
  {
    title: 'main_menu.admin.section.general.providers',
    prefix: '/inventory/provider',
    atLessOne: true,
    items: [
      {
        title: 'supplier:list',
        path: '/inventory/provider/suppliers',
        partialMatch: true,
        icon: <SupplierIcon fontSize='small' />,
        permissions: [SUPPLIER_PERMISSIONS.SUPPLIER_VIEW],
      },
      {
        title: 'logistics:list',
        path: '/inventory/provider/logistics',
        partialMatch: true,
        icon: <LogisticIcon fontSize='small' />,
        permissions: [LOGISTICS_PERMISSIONS.LOGISTICS_VIEW],
      },
      {
        title: 'carriers:list',
        path: '/inventory/provider/carriers',
        partialMatch: true,
        icon: <DriveEtaOutlinedIcon fontSize='small' />,
        permissions: [CARRIER_PERMISSIONS.CARRIER_VIEW],
      },
      /* {
        title: 'manufacture:list',
        path: '/inventory/provider/manufactures',
        partialMatch: true,
        icon: <ManufactureIcon fontSize='small' />,
        permissions: [MANUFACTURE_PERMISSIONS.MANUFACTURE_VIEW],
      }, */
    ],
  },
  {
    title: 'main_menu.admin.section.reports.title',
    prefix: '/inventory/reports',
    atLessOne: true,
    hidden: true,
    items: [
      {
        title: 'main_menu.admin.section.inventory.products',
        path: '/inventory/reports/products',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.inventory.warehouses',
        path: '/inventory/reports/warehouses',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        disabled: true,
      },
      {
        title: 'main_menu.admin.section.inventory.distribution-centers',
        path: '/inventory/reports/distribution-centers',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        disabled: true,
      },
      {
        title: 'category:list',
        path: '/inventory/reports/settings/categories',
        partialMatch: true,
        icon: <AssessmentOutlined fontSize='small' />,
        disabled: true,
      },
    ],
  },
  {
    title: 'main_menu.admin.section.inventory.settings',
    prefix: '/inventory/settings',
    atLessOne: true,
    items: [
      {
        title: 'category:list',
        path: '/inventory/settings/categories',
        partialMatch: true,
        icon: <CategoryIcon fontSize='small' />,
        permissions: [CATEGORY_PERMISSIONS.CATEGORY_VIEW],
      },
      ...(!disableWarehouseAreas ? [{
        title: 'warehouseArea:list',
        path: '/inventory/settings/warehouse-areas',
        partialMatch: true,
        icon: <WarehouseAreaIcon fontSize='small' />,
        permissions: [WAREHOUSE_AREA_PERMISSIONS.WAREHOUSE_AREA_VIEW],
      }] : []),
      ...(!disabledTags ? [{
        title: 'tags:list',
        path: '/inventory/settings/labels',
        partialMatch: true,
        icon: <TagsIcon fontSize='small' />,
        permissions: [LABELS_PERMISSIONS.LABELS_VIEW]
      }] : []),
      ...(!disabledProductVariant ? [{
        title: 'productFeatures:list',
        path: '/inventory/settings/product-features',
        partialMatch: true,
        icon: <ProductFeatureIcon fontSize='small' />,
        permissions: [TAGS_PERMISSIONS.TAGS_VIEW],
      }] : []),
      {
        title: 'productTemplates:list',
        path: '/inventory/settings/product-templates',
        partialMatch: true,
        icon: <DynamicFormOutlinedIcon fontSize='small' />,
        permissions: [PRODUCT_TEMPLATE_PERMISSIONS.PRODUCT_TEMPLATE_VIEW],
      },
      {
        title: 'providerField:list',
        path: '/inventory/settings/provider-fields',
        partialMatch: true,
        icon: <ProviderIcon fontSize='small' />,
        permissions: [PROVIDER_FIELD_PERMISSIONS.PROVIDER_FIELD_VIEW],
      },
      ...(!disabledStockReductionCause ? [{
        title: 'stockReductionCause:list',
        path: '/inventory/settings/stock-reduction-causes',
        partialMatch: true,
        icon: <ReductionCauseIcon fontSize='small' />,
        permissions: [STOCK_REDUCTION_CAUSE_PERMISSIONS.STOCK_REDUCTION_CAUSE_VIEW],
      }] : []),
    ],
  },
];
